import type { FaireProductEntity } from "../../entity_types/product";

export const p_18jz1hk8u9: FaireProductEntity = {
  token: "p_18jz1hk8u9",
  type: "product",
  name: "Cat's Meow Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/c8186bca4233a9215238b1784ec7db71413f2bd839f521d4aa772afade317aa2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/513dd66c49847cc37a1d405f78b3ad3777d40579b98f0d6476f2c1b09467975d.jpeg",
    "https://cdn.faire.com/fastly/a086762f67a1a73861f938e252a2951a0fe221f2a37a4bb86c3faef563316d32.png",
    "https://cdn.faire.com/fastly/4c68d6a24e3279b7a3500854f320bb4edc3e9b9c4613e1e776e5c8761305da46.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:22.225Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
